import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { hydrateRoot, createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';

//const root = ReactDOM.createRoot(document.getElementById('root'));
const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME || '/'}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

if(rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}